import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { AnimatedDigit } from "./AnimatedDigit";
import { gsap } from "gsap";
export const AnimatedYear = ({ year, className }) => {
    const containerRef = useRef(null);
    const prevYearRef = useRef(year);
    useEffect(() => {
        if (containerRef.current && prevYearRef.current !== year) {
            // Легкая анимация для всего контейнера
            gsap.fromTo(containerRef.current, {
                scale: 0.98,
            }, {
                scale: 1,
                duration: 0.3,
                ease: "power2.out",
            });
            prevYearRef.current = year;
        }
    }, [year]);
    return (_jsx("div", { ref: containerRef, className: className, style: { display: "flex" }, children: year.split("").map((digit, index) => (_jsx(AnimatedDigit, { digit: digit, position: index }, index))) }));
};
